import React from "react";
import "./alreadyRegistered.css";
import CustomInput from "../../common/customInput/customInput";
import CustomButton from "../../common/customButton/customButton";

const AlreadyRegistered = ({ onClick }) => {
  return (
    <div className="w-11/12 border-radius h-auto orange-background-registered drop-shadow-lg p-4">
      <div className="flex flex-col justify-between h-auto items-center md:flex-row">
        <h3 className=" flex text-center  mb-4 text-white md:ml-10 md:mb-0  ">
          Already Registered?
        </h3>
        <div className="flex justify-center ">
          <CustomButton onClick={onClick} text={"Log In"} />
        </div>
      </div>
    </div>
  );
};

export default AlreadyRegistered;
